//Handlebars helper to return the sum of two values.
const add = (a, b) => a + b;

module.exports = add;


// WEBPACK FOOTER //
// ./shared/templates/helpers/math.add.helper.js